<template>
  <div v-if="exam">
    <button
      class="btn-primary btn-lg start-exam"
      :data-event="event"
      direct-send
      @click="startExam"
    >
      Get Started
    </button>
    <div class="mobile-warning">
      <WarningIcon /> To attempt the exams please switch to a desktop device.
    </div>
  </div>
  <form
    v-else
    class="download-resource-form"
    @submit="downloadResource"
  >
    <div v-if="!$store.getters['auth/user'].id && !hideFields" class="input-fields">
      <input
        v-model="name"
        class="input full-name"
        type="text"
        placeholder="Full name"
      >
      <input
        v-model="email"
        class="input email"
        type="email"
        placeholder="Email address"
      >
    </div>
    <button
      type="submit"
      :disabled="buttonDisabled"
      class="btn-primary download-resource"
      :data-event="event"
    >
      <DownloadIcon />
      <span> Download </span>
    </button>
    <div v-if="!$store.getters['auth/user'].id && !hideFields" class="terms-holder">
      <div>
        <input
          :id="`terms${$vnode.key}`" v-model="termsAgreed" type="checkbox"
          class="custom-checkbox reverse-colors"
        >
        <label :for="`terms${$vnode.key}`" class="terms">
          I agree to 365 Data Science’s <a target="_blank" href="https://365datascience.com/terms-of-use/">Terms of Use</a> & <a target="_blank" href="https://365datascience.com/privacy-policy/">Privacy Policy</a>
        </label>
      </div>
    </div>
  </form>
</template>

<script>
import DownloadIcon from '../../assets/svg/icon-download.svg?vue-component';
import WarningIcon from '../../assets/svg/warning.svg?vue-component';

export default {
  components: { DownloadIcon, WarningIcon },
  props: {
    hideFields: { type: Boolean },
    exam: { type: Boolean },
    examId: { type: Number, default: 0 },
    event: { type: String, default: '' },
    category: { type: String, default: '' },
  },
  data() {
    return {
      email: '',
      name: '',
      termsAgreed: '',
    };
  },
  computed: {
    buttonDisabled() {
      if (this.$store.getters['auth/user'].id || this.hideFields) {
        return false;
      }

      return !this.email || !this.name || !this.$validEmail(this.email) || !this.termsAgreed;
    },
  },
  methods: {
    async downloadResource(event) {
      event.preventDefault();

      if (!this.hideFields && (!this.$store.getters['auth/user'].id && (!this.email || !this.name || !this.$validEmail(this.email)))) {
        return;
      }

      const { file, slug } = await this.$axios.$post(`/resources/${this.$route.params.slug}/download`, { name: this.name, email: this.email });

      const link = document.createElement('a');
      link.href = `${this.$config.imagesUrl}/resources/${file}`;
      const ext = file.split('.').pop();
      link.setAttribute('download', `${slug}.${ext}`);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        this.$router.push(`/ty-downloadable-resources/?resourcesCategory=${this.category}`);
      }, 300);
    },
    async startExam() {
      await this.$axios.$post(`/resources/${this.$route.params.slug}/download?exam=1`);
      this.$router.push(`/resources-center/exams/${this.examId}/instructions/`);
    },
  },
};
</script>

<style lang="scss" scoped>
.start-exam {
  display: block;
  width: 100%;
  max-width: 308px;
  margin-top: 48px;
}

.mobile-warning {
  display: none;
}

.download-resource-form {
  .download-resource {
    padding: var(--spacing-18) 0;

    svg {
      margin-right: 0;
    }
  }
}

@include bp($bp-mobile) {
  .start-exam {
    display: none;
  }

  .mobile-warning {
    border: 1px solid var(--main-light-shade-4);
    border-radius: 10px;
    padding: var(--spacing-8) var(--spacing-32);
    margin-top: var(--spacing-32);
    display: flex;
    align-items: center;
    color: var(--main-light);

    svg {
      flex: 0 0 auto;
      margin-right: var(--spacing-12);

      > path:first-child {
        fill: var(--main-dark-light-4);
      }
    }
  }
}
</style>
